<div class="container py-3">
  <h2 class="mb-3">Admin Tools</h2>


    <div>
      <div class="subsection mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2 subheader">
          <h4 class="m-0 subsection-title">JWT Token Issued from Auth0</h4>
          <div>
            <button class="btn btn-primary btn-sm me-1" (click)="showAccessToken()">Token</button>
            <button class="btn btn-primary btn-sm me-1" (click)="showDecodedToken()">Token Claim</button>
            <button class="btn btn-primary btn-sm" (click)="retrieveUserPermissions()">Permissions</button>
          </div>
        </div>
        <div>
          <p>You could show your Auth0 account token, token claims, and permissions. </p>
          <div class="api-response">
            <div *ngIf="currentResponse">{{ currentResponse | json }}</div>
          </div>
        </div>
      </div>
      <!-- Test by API key subsection (inserted) -->
      <div class="subsection mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2 subheader">
          <h4 class="m-0 subsection-title">Test by API key</h4>
          <button class="btn btn-primary btn-sm" [disabled]="apiKeyLoading" (click)="testByApiKey()">Test</button>
        </div>
        <div>
          <div class="mb-2" style="max-width: 640px;">
            <label class="form-label">API Key (request header: secret)</label>
            <input class="form-control form-control-sm" [(ngModel)]="apiKey"/>
          </div>
          <pre class="bg-light p-2" style="white-space: pre-wrap; max-height: 300px; overflow: auto;">{{ apiKeyResultText }}</pre>
        </div>
      </div>
      <div class="subsection mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2 subheader">
          <h4 class="m-0 subsection-title">Backend Access Level Test</h4>
          <button class="btn btn-primary btn-sm" (click)="request()">Test</button>
        </div>
        <div>
          <p>You can verify the access level of your current token to the backend.</p>
          <div class="api-response">
            <div *ngIf="public$">
              <div >Public: {{ public$ | async | json }}</div>
              <div >Private: {{ private$ | async | json }}</div>
              <div >PrivateScoped: {{ privateScoped$ | async | json }}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isAdmin" class="subsection mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2 subheader">
          <h4 class="m-0 subsection-title">Encrypt key by configure server</h4>
          <button class="btn btn-primary btn-sm" [disabled]="encryptLoading" (click)="encryptByConfigServer()">Encrypt</button>
        </div>
        <div>
          <div class="mb-2" style="max-width: 640px;">
            <label class="form-label">Text to encrypt</label>
            <input class="form-control form-control-sm" [(ngModel)]="encryptInput" placeholder="Enter text to encrypt…"/>
          </div>
          <div class="mb-2" style="max-width: 640px;">
            <label class="form-label">Encrypt endpoint URL</label>
            <input class="form-control form-control-sm" [(ngModel)]="encryptUrl" placeholder="Enter encrypt endpoint URL…"/>
          </div>
          <pre class="bg-light p-2" style="white-space: pre-wrap; max-height: 300px; overflow: auto;">{{ encryptResultText }}</pre>
        </div>
      </div>
      <div *ngIf="isAdmin" class="subsection mt-3">
        <div class="d-flex justify-content-between align-items-center mb-2 subheader">
          <h4 class="m-0 subsection-title">Decrypt key by configure server</h4>
          <button class="btn btn-primary btn-sm" [disabled]="decryptLoading" (click)="decryptByConfigServer()">Decrypt</button>
        </div>
        <div>
          <div class="mb-2" style="max-width: 640px;">
            <label class="form-label">Text to decrypt</label>
            <input class="form-control form-control-sm" [(ngModel)]="decryptInput" placeholder="Enter text to decrypt…"/>
          </div>
          <div class="mb-2" style="max-width: 640px;">
            <label class="form-label">Decrypt endpoint URL</label>
            <input class="form-control form-control-sm" [(ngModel)]="decryptUrl" placeholder="Enter decrypt endpoint URL…"/>
          </div>
          <pre class="bg-light p-2" style="white-space: pre-wrap; max-height: 300px; overflow: auto;">{{ decryptResultText }}</pre>
        </div>
      </div>
    </div>
</div>

<!-- Admin dashboard actions moved to NTRIP Server Admin page -->